<template>
  <v-card>
    <v-data-table :headers="headers"
                  :items="videos"
                  :options.sync="options"
                  :footer-props="dataTableFooterProps"
                  :server-items-length="totalVideos"
                  :loading="videosLoading"
                  disable-sort
                  loading-text="Loading... Please wait">

      <template v-slot:top>
        <v-card-title class="grey--text text--darken-2">
          <v-icon class="mx-3">
            mdi-play-box-multiple-outline
          </v-icon>
          Vimeo/Youtube Resources
        </v-card-title>

        <v-card-title>
          <v-btn class="mr-5 ml-2"
                 rounded
                 color="primary"
                 dark
                 x-large
                 @click="addItem()"
          >
            <v-icon
            >
              mdi-plus
            </v-icon>
            Add a Vimeo/Youtube
          </v-btn>

          <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search Videos"
              single-line
              hide-details
              filled
              rounded
              placeholder="Search videos"
              class="mr-5"
              clearable
              @click="clear"
              color="primary"
          ></v-text-field>

          <RefreshTableHeader :action="refresh" />

        </v-card-title>
      </template>

      <template v-slot:item.actions="{ item }">

        <v-btn x-small
               depressed
               class="pa-3 ma-1"
               @click="editItem(item)">
          <v-icon small>
            mdi-pencil
          </v-icon>
        </v-btn>

        <v-btn
            x-small
            depressed
            @click="deleteItem(item)"
            class="pa-3 ma-1">
          <v-icon small color="primary">
            mdi-close
          </v-icon>
        </v-btn>
      </template>

      <template v-slot:[`footer.page-text`]="items">
        <RefreshTableFooter :item="items" :action="refresh"/>
      </template>

    </v-data-table>

    <VideoAdd/>
    <VideoEdit/>
    <VideoDelete/>
  </v-card>
</template>

<script>
import { mapGetters, mapState, mapActions } from "vuex";
import VideoDelete from "@/components/Videos/VideoDelete";
import VideoEdit from "@/components/Videos/VideoEdit";
import VideoAdd from "@/components/Videos/VideoAdd";
import RefreshTableHeader from "@/components/common/RefreshTableHeader";
import RefreshTableFooter from "@/components/common/RefreshTableFooter";
import {debounce} from "@/utility";

export default {
  name: "Videos",
  components: {RefreshTableHeader, RefreshTableFooter, VideoAdd, VideoEdit, VideoDelete},
  computed: {
    ...mapState([
      'videosLoading', 'totalVideos',
    ]),
    ...mapGetters([
        'videos', 'videosLoading', 'totalVideos', 'currentVideoItem', 'dataTableFooterProps',
    ]),
  },
  methods: {
    ...mapActions([
      'getVideos', 'getVideo', 'clearVideoApiError',
      'setOpenDialog', 'setVideoPaginationOptions', 'setVideosSearch',
    ]),
    addItem() {
      this.clearVideoApiError();
      this.setOpenDialog('videoAdd');
    },
    async editItem(item) {
      this.clearVideoApiError();
      this.setOpenDialog('videoEdit');
      await this.getVideo(item);
      if (!this.currentVideoItem) {
        this.getVideos();
      }
    },
    async deleteItem(item) {
      this.clearVideoApiError();
      this.setOpenDialog('videoDelete');
      await this.getVideo(item);
      if (!this.currentVideoItem) {
        this.getVideos();
      }
    },
    refresh() {
      this.getVideos();
    },
    clear() {
      this.setVideosSearch('');
    },
  },
  mounted () {
    this.setVideosSearch('');
    this.getVideos();
  },
  data() {
    return {
      search: '',
      debouncedSearch: '',
      options: {
        itemsPerPage: 10,
      },
      headers: [
        {
          text: 'ID',
          align: 'start',
          value: '_id',
        },
        {
          text: 'Title',
          align: 'start',
          value: 'title',
        },
        {
          text: 'Description',
          align: 'start',
          value: 'description',
        },
        {
          text: 'Aspect Ratio',
          align: 'start',
          value: 'aspectRatio',
        },
        {
          text: 'URI',
          align: 'start',
          value: 'uri',
        },
        {
          text: 'Actions',
          value: 'actions',
          sortable: false,
        },
      ],
    };
  },
  watch: {
    options: {
      handler() {
        this.setVideoPaginationOptions(this.options);
        this.getVideos();
      },
      deep: true,
    },
    search: debounce(function(newVal) {
      this.debouncedSearch = newVal;
    }, 500),
    debouncedSearch: {
      handler() {
        this.setVideosSearch(this.search ?? '');
        this.getVideos();
      },
    },
  },
};
</script>